import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { StorageService } from './core/services/storage.service';
import { environment, environment as env } from '../environments/environment';

@Component({
  standalone: false,
  selector: 'nft-folks-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isProd = env.production;
  envName = env.envName;
  version = env.versions.app;

  constructor(
    private storageService: StorageService,
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.storageService.testLocalStorage();
    this.printAppInfo();
    this.removeLoadingClass();
  }

  removeLoadingClass() {
    this.renderer.removeClass(document.body, 'loading');
  }

  printAppInfo() {
    this.http
      .get('/assets/manifest.json')
      .toPromise()
      .then((manifest: any) => {
        let message = `${environment.appName}
    Environment: ${this.envName}
    Version: ${this.version}
    `;
        if (manifest) {
          message =
            message +
            `built: ${manifest.appBuildDate}
    commit: ${manifest.gitCommitHash}
    git tag: ${manifest.gitCommitTag}
      `;
        }
        // tslint:disable-next-line:no-console
        console.log(message);
      });
  }
}
